export default {
	data() {
		return { isNull: false };
	},
	props: {
		gridViewField: Object,
		defaultGridView: Object,
		item: Object,
		record: Object,
		tabIndex: Number,
		isBulkEdit: Boolean,
	},
	computed: {
		key() {
			if (!this.gridViewField) return null;
			if (!this.gridViewField.DataField) return null;
			return this.gridViewField.DataField.FieldName;
		},
	},
};
